import { UsersIcon } from '@heroicons/react/24/outline'

// Curry Me Club › Members. The sidebar entry exists from stage 2 (owner
// 2026-09-21: the club is its own group with Programs and Members); the member
// admin itself — search, card, wallet, adjustments with a reason, the audit
// trail and the flagged list (wireframe P06, contract §6 "Members") — is stage
// 3 and replaces this placeholder.

const LoyaltyMembersPage = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Members</h1>
      <p className="mt-1 text-sm text-gray-500">
        Look up a member, see their card and wallet, adjust stamps with a reason.
      </p>
    </div>
    <div className="rounded-lg border border-dashed border-gray-300 bg-white p-12 text-center">
      <UsersIcon className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-4 text-sm font-semibold text-gray-900">Not available yet</h3>
      <p className="mt-2 text-sm text-gray-500">
        Member administration arrives with the next stage of the club.
      </p>
    </div>
  </div>
)

export default LoyaltyMembersPage
